"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorLike = isErrorLike;
exports.isOverconstrainedError = isOverconstrainedError;
function isErrorLike(err) {
    if (err == null || typeof err !== "object") {
        return false;
    }
    return err.message !== undefined && err.name !== undefined;
}
function isOverconstrainedError(err) {
    return err.constraint !== undefined && err.name !== undefined && err.message !== undefined;
}
//# sourceMappingURL=dom-exception.js.map